<div>
    <div class="cancel_details">
        <div class="dlt">
            <div>
                <img src="../../../../assets/image/mdi_alert.svg" alt="">
            </div>
            <div>
                <span class="Dlt_title">Delete Filter</span>
            </div>
        </div>
        <p class="dlt_mge">Are you sure you want to delete this filter?</p>
        <div class="selected_list">
            <button class="cancel" (click)="cancel()">Cancel</button>
            <button class="delete" (click)="delete()">Delete</button>
        </div>
    </div>
</div>

